import React, { useEffect, useState } from 'react'
// import PropTypes from 'prop-types'
import { useDispatch, useSelector } from 'react-redux'
import { Field, Formik, Form } from 'formik'
import { openModal } from '../common/modals/modalActions'
import Carousel from 'react-bootstrap/Carousel'
import ReactGA4 from "react-ga4";
import landIcon from '../common/assets/icons/shared-earth-icons-11.svg'
import matchIcon from '../common/assets/icons/shared-earth-icons-12.svg'
import fruitsIcon from '../common/assets/icons/shared-earth-icons-13.svg'
import bgHowImage from '../common/assets/images/abby-shovel.jpg'
// import bgVideo from '../common/assets/images/SE-marketing-page-1.jpg'
import bgCommunityImage from '../common/assets/images/SE-marketing-page-2.jpg'
import communityImage from '../common/assets/images/SE-marketing-page-6.jpg'
import shopImage from '../common/assets/images/shared-earth-merch-image.jpg'
import donateImage from '../common/assets/images/SE-marketing-page-4.jpg'
import bgWhyImage from '../common/assets/images/SE-marketing-page-3.jpg'
import saLogo from '../common/assets/Sustainable-America-Alternate-Logo.svg'
import mapGraphic from '../common/assets/illustrations/SE-homepage-map.svg'
import haveIcon from '../common/assets/icons/map-have-icon.svg'
import needIcon from '../common/assets/icons/map-want-icon.svg'
import { getPublicLocationsFromLocation } from '../common/locations/locationsAction'

import { AddressInputMap } from '../common/fields'
import { history } from '../common/utils/history'
import { useRef } from 'react'

const Homepage = () => {
  const dispatch = useDispatch()
  const foundLocationRef = useRef(null)
  const pageQuery = useSelector((state) => state.router.location.query)
  const [foundLocations, setFoundLocations] = useState({
    need: 0,
    have: 0,
    show: false
  })

  useEffect(() => {
    if (pageQuery.showLoginModal) {
      dispatch(openModal('LoginModal'))
    }
    if (pageQuery.showSignupModal) {
      dispatch(openModal('SignupModal'))
    }
    if (pageQuery.showAuthCodeModal) {
      dispatch(openModal('AuthCodeModal'))
    }
    if (pageQuery.showResetPasswordModal) {
      const modalMessage = pageQuery.returning
        ? 'Some things have changed, to get started please enter your verification code sent to your email address and provide a new password'
        : 'To reset your password, please check your email for an auth code'
      dispatch(openModal('ResetPasswordModal', { modalMessage }))
    }
    if (pageQuery.showResetPasswordRequestModal) {
      dispatch(openModal('ResetPasswordRequestModal'))
    }
    /* eslint-disable */
  }, [pageQuery])

  const addressInputHandler = async (values) => {
    const distance = 100
    const location = values.location.geom
    try {
      const locations = await dispatch(
        getPublicLocationsFromLocation({ distance, location })
      )
      localStorage.setItem('signUpAddress', JSON.stringify(values.location)) // stored in local storage to be used during the complete profile modal if it exists
      setFoundLocations({ ...locations, show: true })
      if (foundLocationRef.current) {
        foundLocationRef.current.scrollIntoView({
          behavior: 'auto'
        })
      }
    } catch (error) {
      console.log(error)
    }
  }

  return (
    <>
      <section
        id='homeIntro'
        className='bg-image aspect-auto text-white bg-gradient-md'
      >
        <div className='container'>
          <div className='row'>
            <div className='col-12 col-lg-8 mx-lg-auto'>
              <h1 ref={foundLocationRef} className='text-center display-3'>
                Connecting Land Owners
                <br className='d-none d-xl-block' /> with Gardeners
              </h1>
              {!foundLocations.show && (
                <>
                  <div className='row justify-content-center align-items-center no-gutters-sm mt-5'>
                    <div className='col-5 col-md-4 col-xl-3 text-center'>
                      <img
                        src={needIcon}
                        className='img-fluid'
                        alt='I need space icon'
                      />
                    </div>
                    <div className='col-2 text-center display-4 align-self-center'>
                      <i className='fas fa-arrows-alt-h'></i>
                    </div>
                    <div className='col-5 col-md-4 col-xl-3 text-center'>
                      <img
                        src={haveIcon}
                        className='img-fluid'
                        alt='I have Garden space icon'
                      />
                    </div>
                  </div>
                  <div className='row justify-content-center no-gutters-sm'>
                    <div className='col-5 col-md-4 col-xl-3 text-center'>
                      <p className='lead mt-3'>
                        I am a<br />
                        Gardener
                      </p>
                    </div>
                    <div className='col-2'></div>
                    <div className='col-5 col-md-4 col-xl-3 text-center'>
                      <p className='lead mt-3'>
                        I Have
                        <br /> Land to Share
                      </p>
                    </div>
                  </div>
                </>
              )}
            </div>
          </div>
          <div className='row pb-lg-5'>
            <div className='col-12 col-lg-8 mx-lg-auto'>
              {foundLocations.need > 0 &&
                foundLocations.have > 0 &&
                foundLocations.show && (
                  <div className='bg-white text-dark p-3 p-lg-5 mt-5 rounded'>
                    <div className='row align-items-center'>
                      <div className='col-12 col-lg-6'>
                        <div className='text-center mb-3 mb-lg-0 p-lg-5'>
                          <h2>There are members in your area!</h2>
                          <button
                            className='btn btn-blue-light d-none d-lg-inline-block mt-3'
                            onClick={() => {
                              dispatch(openModal('SignupModal'))
                              history.push('?showSignupModal=true')
                            }}
                          >
                            Sign Up
                          </button>
                        </div>
                      </div>
                      <div className='col-12 col-lg-6'>
                        <div className='row'>
                          <div className='col-6 col-lg-12'>
                            <div className='row row-found-locations mb-3 align-items-center'>
                              <div className='col-8 col-md-5 mx-auto col-lg-3'>
                                <img
                                  alt='Have space icon'
                                  src={needIcon}
                                  className='img-fluid'
                                />
                              </div>
                              <div className='col-12 col-lg-9 text-center text-lg-left'>
                                {foundLocations.need} members
                                <br className='d-block d-md-none' /> are
                                gardeners
                              </div>
                            </div>
                          </div>
                          <div className='col-6 col-lg-12'>
                            <div className='row row-found-locations align-items-center'>
                              <div className='col-8 col-md-5 mx-auto col-lg-3'>
                                <img
                                  alt='Have space icon'
                                  src={haveIcon}
                                  className='img-fluid'
                                />
                              </div>
                              <div className='col-12 col-lg-9 text-center text-lg-left'>
                                {foundLocations.have} members
                                <br className='d-block d-md-none' /> have land
                                to share
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                    <div className='d-block d-lg-none'>
                      <div className='row'>
                        <div className='col-12'>
                          <button
                            className='btn btn-blue-light btn-block btn-lg-inline-block mt-3'
                            onClick={() => {
                              dispatch(openModal('SignupModal'))
                              history.push('?showSignupModal=true')
                            }}
                          >
                            Sign Up
                          </button>
                        </div>
                      </div>
                    </div>
                  </div>
                )}
              {foundLocations.need <= 0 &&
                foundLocations.have <= 0 &&
                foundLocations.show && (
                  <div className='row mt-5'>
                    <div className='col-12'>
                      <div className='bg-light rounded text-center text-dark p-3 p-lg-5'>
                        <h2 className='mb-3 mb-lg-0'>
                          There are a few members in your area, sign up to join
                          them and grow the community!
                        </h2>
                        <button
                          className='btn btn-blue-light mt-4'
                          onClick={() => {
                            dispatch(openModal('SignupModal'))
                            history.push('?showSignupModal=true')
                          }}
                        >
                          Sign Up
                        </button>
                      </div>
                    </div>
                  </div>
                )}

              <Formik
                enableReinitialize
                initialValues={{}}
                onSubmit={(values, { resetForm }) =>
                  addressInputHandler(values, resetForm)
                }
              >
                {({ errors, values, setFieldValue, dirty }) => (
                  <div className='row justify-content-center'>
                    <div className='col-12 col-lg-10'>
                      <Form
                        id='address-input-form'
                        className='input-group input-group-lg mt-5 mb-2'
                      >
                        <Field
                          name='formatted_address'
                          type='text'
                          component={AddressInputMap}
                          placeholder='Enter Your Address'
                          showMap={false}
                          className='position-relative'
                          onChange={(value) => {
                            setFieldValue('formatted_address', value)
                          }}
                        />
                        <button
                          type='submit'
                          form='address-input-form'
                          className={`btn btn-blue-light text-white ${
                            dirty ? '' : 'btn-disabled'
                          }`}
                          disabled={
                            dirty
                              ? false
                              : true || Object.keys(errors).length > 0
                          }
                        >
                          Search{' '}
                          <span className='d-none d-sm-inline-block'>
                            my area
                          </span>
                        </button>
                      </Form>
                    </div>
                  </div>
                )}
              </Formik>

              {/* <p className='text-center mt-3'>
                We will never share your address without your permission. View
                our{' '}
                <a href='/privacy-policy' className='text-white text-underline'>
                  privacy policy
                </a>
                .
              </p> */}
            </div>
          </div>
          <div className='row mt-4 mt-5'>
            <div className='col-12 text-center'>
              <p className='mb-0'>
                <small>
                  Already have an account? &nbsp;
                  <a
                    href='#link'
                    className='text-underline text-white link-login'
                    onClick={(e) => {
                      e.preventDefault()
                      dispatch(openModal('LoginModal'))
                    }}
                  >
                    Login
                  </a>
                </small>
              </p>
              <p>Scroll down to learn more.</p>
            </div>
          </div>
        </div>
      </section>
      <section id='help'>
        <div className='container'>
          <div className='row'>
            <div className='col-12 col-lg-11 mx-lg-auto'>
              <h1 className='display-4 text-center'>
                Help us make better use of the planet, one garden at a time
              </h1>
            </div>
          </div>
          <div className='row mt-5'>
            <div className='col-lg-4 text-center mb-5 mb-lg-0'>
              <img src={landIcon} className='img-fluid' alt='Land Icon' />
              <h2>Land is everywhere</h2>
              <p>
                There are over 40 million acres of unproductive land in
                residential backyards and commercial properties and over 19
                million abandoned properties across the U.S. Let’s start using
                them! Discover available plots of land and gardeners or farmers
                and start growing food together.
              </p>
            </div>
            <div className='col-lg-4 text-center mb-5 mb-lg-0'>
              <img src={matchIcon} className='img-fluid' alt='Land Icon' />
              <h2>Find your match</h2>
              <p>
                Shared Earth connects people who have land, with people who want
                to garden or farm. Search listings and message with nearby
                gardeners or landowners to get started on your next garden!
              </p>
            </div>
            <div className='col-lg-4 text-center mb-5 mb-lg-0'>
              <img src={fruitsIcon} className='img-fluid' alt='Land Icon' />
              <h2>Enjoy the fruits of your labor</h2>
              <p>
                Not only will you enjoy fresh, local food— you will make a
                difference in our food system, create communities and raise
                awareness around local food and health.
              </p>
            </div>
          </div>
        </div>
      </section>
      <section
        id='how-it-works'
        className='bg-image bg-three-quarters text-white'
        style={bgHowImage && { backgroundImage: `url(${bgHowImage})` }}
      >
        <div className='container'>
          <div className='row'>
            <div className='col-12 text-center'>
              <h1 className='display-4'>How it Works</h1>
              <button
                className='play-video mt-lg-5 bg-transparent text-white border-0 mx-auto'
                onClick={() =>
                  dispatch(
                    openModal('VideoModal', {
                      src: 'https://player.vimeo.com/video/131261693?autoplay=1'
                    })
                  )
                }
              >
                <i className='far fa-play-circle'></i>
              </button>
            </div>
          </div>
        </div>
      </section>
      <section>
        <div className='container'>
          <div className='row'>
            <div className='col-12 col-lg-9 mx-lg-auto mb-5'>
              <h1 className='display-4 text-center'>
                Over 15k members and gardens around the United States.
              </h1>
            </div>
          </div>
          <div className='row mt-lg-5'>
            <div className='col-12 col-lg-7 mx-lg-auto'>
              <img
                src={mapGraphic}
                className='img-fluid rounded d-block mx-auto'
                alt='Map Graphic'
              />
            </div>
          </div>
        </div>
      </section>
      <section
        className='bg-image aspect-auto text-white bg-gradient-md'
        style={
          bgCommunityImage && { backgroundImage: `url(${bgCommunityImage})` }
        }
      >
        <div className='container'>
          <div className='row pb-5'>
            <div className='col-12 col-lg-9 mx-lg-auto'>
              <h1 className='display-4 text-center'>
                The Shared Earth community gets bigger every day.
              </h1>
            </div>
          </div>
          <div className='row mt-5'>
            <div className='col-lg-6 order-2 order-lg-1'>
              <h3 className='mb-0'>Tom</h3>
              <p>
                <small>Austin, TX</small>
              </p>
              <p className='lead mb-3'>
                “It was just a rough patch of land when we started. Now there is
                a vibrant garden growing. Lauren’s mother is a gardener and she
                loves to garden, she just didn’t have the land for one. I love
                fresh fruits and vegetables, but don’t have the patience or time
                to tend to it. We came up with a great plan and now have a
                productive garden that is beautiful and lush. Thanks for
                everything!”
              </p>
            </div>
            <div className='col-8 col-lg-4 mx-auto ml-lg-auto order-1 order-lg-2'>
              <div
                style={
                  communityImage && {
                    backgroundImage: `url(${communityImage})`
                  }
                }
                className='bg-image aspect-1x1 rounded-circle border border-white'
              />
            </div>
          </div>
        </div>
      </section>
      <section id='carousel-section'>
        <div className='container'>
          <div className='row d-none d-lg-flex'>
            <div className='col-12 col-lg-8 mx-lg-auto'>
              <h1 className='text-center display-4'>Support Shared Earth</h1>
            </div>
          </div>
          <div className='row mt-lg-5'>
            <div className='col-12 col-lg-8 mx-lg-auto'>
              <Carousel indicators={false} className='shadow'>
                <Carousel.Item>
                  <div className='bg-light'>
                    <div className='row no-gutters w-100'>
                      <div className='col-12 col-lg-8'>
                        <div className='px-4 pt-5 pb-4 p-lg-5 d-flex flex-column h-100 justify-content-between'>
                          <div>
                            <h4>Shared Earth Merchandise</h4>
                            <p>Shop the official store today!</p>
                          </div>
                          <div className='mt-3'>
                            <a
                              href={process.env.REACT_APP_SHOPIFY_URL}
                              className='btn btn-lg btn-blue-light'
                              target='_blank'
                              rel='noreferrer'
                            >
                              Shop Merchandise
                            </a>
                          </div>
                        </div>
                      </div>
                      <div className='col-12 col-lg-4'>
                        <div
                          className='bg-image aspect-1x1 bg-contain bg-white'
                          style={
                            shopImage && {
                              backgroundImage: `url(${shopImage})`
                            }
                          }
                        />
                      </div>
                    </div>
                  </div>
                </Carousel.Item>
                <Carousel.Item>
                  <div className='bg-light'>
                    <div className='row no-gutters w-100'>
                      <div className='col-12 col-lg-8'>
                        <div className='px-3 py-5 p-lg-5 d-flex flex-column h-100 justify-content-between'>
                          <div>
                            <h4>Donate to Shared Earth</h4>
                            <p>
                              Help support our mission with a tax deductible
                              donation!
                            </p>
                          </div>
                          <div className='mt-3'>
                            <button
                              onClick={() => {
                                ReactGA4.event({
                                  category: 'Manual Donation Modal Event',
                                  action: 'Donation Modal Open'
                                })
                                history.push('?showDonationModal=true')
                                dispatch(openModal('DonateModal'))
                              }}
                              className='btn btn-lg btn-blue-light'
                            >
                              Donate
                            </button>
                            <p className='mt-3'>
                              Learn more about Shared Earth by watching the
                              video below.
                            </p>
                          </div>
                        </div>
                      </div>
                      <div className='col-12 col-lg-4 d-none d-lg-block'>
                        <div
                          className='bg-image aspect-1x1'
                          style={
                            donateImage && {
                              backgroundImage: `url(${donateImage})`
                            }
                          }
                        />
                      </div>
                    </div>
                  </div>
                </Carousel.Item>
              </Carousel>
            </div>
          </div>
        </div>
      </section>
      <section
        className='bg-image bg-three-quarters text-white'
        style={bgWhyImage && { backgroundImage: `url(${bgWhyImage})` }}
      >
        <div className='container'>
          <div className='row'>
            <div className='col-12 text-center'>
              <h2 className='display-4'>Why Shared Earth</h2>
              <button
                className='play-video mt-lg-5 bg-transparent text-white border-0'
                onClick={() =>
                  dispatch(
                    openModal('VideoModal', {
                      src: 'https://www.youtube.com/embed/90wXcudmVrI?autoplay=1&mute=1'
                    })
                  )
                }
              >
                <i className='far fa-play-circle'></i>
              </button>
            </div>
          </div>
        </div>
      </section>
      <section id='sign-up'>
        <div className='container'>
          <div className='row'>
            <div className='col-12 text-center'>
              <h2 className='display-4'>Sign up today</h2>
              <p className='lead font-w-bold mt-4'>
                Join the land sharing movement.
              </p>
              <button
                onClick={() => {
                  dispatch(openModal('SignupModal'))
                  history.push('?showSignupModal=true')
                }}
                className='btn btn-lg btn-blue-light mt-4'
              >
                Sign Up
              </button>
            </div>
          </div>
        </div>
      </section>
      <section id='presented-by' className='bg-dark text-white'>
        <div className='container'>
          <div className='row'>
            <div className='col-12 text-center'>
              <h2 className='display-4'>Presented by Sustainable America</h2>
            </div>
          </div>
          <div className='row mt-5'>
            <div className='col-12 col-lg-6 mx-lg-auto text-center'>
              <p>
                Shared Earth is a project of Sustainable America, a 501(c)(3)
                non-profit organization with the mission to make America’s food
                and fuel systems more efficient and resilient. Sustainable
                America supports initiatives like Shared Earth that encourage
                local food production, increased access to healthy food and
                reduced energy use.
              </p>
              <p className='my-5'>
                <a
                  href='https://sustainableamerica.org/contact'
                  className='btn btn-lg btn-blue-light'
                  target='_blank'
                  rel='noreferrer'
                >
                  Learn More &amp; Subscribe
                </a>
              </p>
              <img
                src={saLogo}
                className='img-fluid mt-4'
                alt='Sustainable America Logo'
              />
            </div>
          </div>
        </div>
      </section>
    </>
  )
}

export default Homepage
